import * as React from 'react';
import { sanObj } from '../scbsite/sanObj';


interface IProps {
    text: string;
    href: string;
    trackingAction: string;
    trackingCluster: string;
    gaLabel: string;
}

export const CTA = ({ text, href, trackingAction, trackingCluster, gaLabel }: IProps) => {

    const trackingAdform = (project, cluster, action, label) => (e:React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        let category = "repeatbusiness";
        let gaAction = trackingCluster;
        sanObj.callGA_action(gaAction, category, label);
        sanObj.trackingAdfClick(project + "|" + cluster + "|" + action);
        
        setTimeout(() => {
            window.location.assign(href);
        }, 1500);

        return false;
    }

    return <a className="cta" href="#" onClick={trackingAdform("repeat_business", trackingCluster, trackingAction, gaLabel)}>
        <h2 className="cta-fontsize">
            {text}
        </h2>
    </a>
}